// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchQuestions_root__3FjmV"};